const filterLiveChartData = (chartData) => {
    if (!Array.isArray(chartData)) return chartData;
    const hasIsLiveFlag = chartData.some(item =>
        Object.prototype.hasOwnProperty.call(item || {}, "IsLive")
    );
    return hasIsLiveFlag
        ? chartData.filter(item => item?.IsLive === true)
        : chartData;
};

const filterLiveRankingData = (chartData) => {
  if (!Array.isArray(chartData)) return chartData;

  return chartData.map(entry => {
    const suppliers = Array.isArray(entry?.Suppliers) ? entry.Suppliers : [];
    const hasIsLiveFlag = suppliers.some(supplier =>
      Object.prototype.hasOwnProperty.call(supplier || {}, "IsLive")
    );

    return {
      ...entry,
      Suppliers: hasIsLiveFlag
        ? suppliers.filter(supplier => supplier?.IsLive === true)
        : suppliers,
    };
  });
};

export const convertToApexChartsPlots = (priceTrendData, key=null) => {

    if(!priceTrendData) return null;
    priceTrendData = filterLiveChartData(priceTrendData);
    const uniqueDates = [];
    // Collect all unique dates
    priceTrendData.forEach(supplierData => {
        supplierData.Prices.forEach(priceEntry => {
            if (uniqueDates.includes(priceEntry.Date)) return; // Skip if date already exists
            uniqueDates.push(priceEntry.Date);
        });
    });

    // Convert uniqueDates Set to an array and sort it (optional)
    const sortedDates = Array.from(uniqueDates).sort((a, b) => new Date(a) - new Date(b));

    // Map prices for each supplier
    const result = priceTrendData.map((supplierData, index) => {
        const pricesForSupplier = sortedDates.map(date => {
            const priceEntry = supplierData.Prices.find(p => p.Date === date);
            return priceEntry ? priceEntry.Price : null;
        });

        return {
            name: supplierData.Supplier,
            supplierId: supplierData.EnerexSupplierIdentifier,
            type: "line", //"index==0?"line":"column",
            data: pricesForSupplier
        };
    });

    const formattedDates = sortedDates.map(date => {
    if (!date) return "";
    if (key.includes("forwardCurve")) {
        // input “MM/DD/YY” → output “MM/YY”
        const [MM, , YY] = date.split('/');
        return `${MM}/${YY}`;
    }
    // default “MM/DD”
    return date.slice(0, 5);
    });

    return {categories: formattedDates, series: result};
}

export const convertToApexChartsMinMaxPlots = (priceTrendData, key=null) => {

    if(!priceTrendData) return null;
    priceTrendData = filterLiveChartData(priceTrendData);
    const uniqueDates = [];
    const minPriceSeriesData = [];
    const maxPriceSeriesData = [];
    const meanPriceSeriesData = [];
    const priceSeries = [];
    const SupplierName = priceTrendData[0]?.Prices?.[0]?.Supplier || 'Your Supplier';
    // Collect all unique dates
    priceTrendData.forEach(supplierData => {
        supplierData.Prices.forEach(priceEntry => {
            uniqueDates.push(priceEntry.Date);
        });
    });

    // Convert uniqueDates Set to an array and sort it (optional)
    const sortedDates = Array.from(uniqueDates).sort((a, b) => new Date(a) - new Date(b));

    // Map min & max series
    sortedDates.forEach(date => {
        // Assumes only one supplier per day, or takes the first matching
        const entry = priceTrendData.find(s =>
          s.Prices.some(p => p.Date === date)
        );
        const priceEntry = entry?.Prices.find(p => p.Date === date);
        minPriceSeriesData.push(priceEntry?.MinPrice ?? null);
        maxPriceSeriesData.push(priceEntry?.MaxPrice ?? null);
        meanPriceSeriesData.push(priceEntry?.MeanPrice ?? null);
        priceSeries.push(priceEntry?.Price ?? null);
      });

    const result = [
        {
            name: SupplierName,
            type: 'line',
            data: priceSeries        
        },
        {
            name: 'Min Price',
            type: 'line',
            data: minPriceSeriesData,
        },
        {
            name: 'Max Price',
            type: 'line',
            data: maxPriceSeriesData,
        },
        {
            name: 'Mean Price',
            type: 'line',
            data: meanPriceSeriesData,
        },
    ];

    const formattedDates = sortedDates.map(date => {
    if (!date) return "";
    if (key.includes("forwardCurve")) {
        // input “MM/DD/YY” → output “MM/YY”
        const [MM, , YY] = date.split('/');
        return `${MM}/${YY}`;
    }
    // default “MM/DD”
    return date.slice(0, 5);
    });

    return {categories: formattedDates, series: result};
}


export const XconvertDeltaBestToChartData = (priceTrendData, key = null) => {
  if (!priceTrendData) return null;

  const uniqueDates = [...new Set(priceTrendData.map(entry => entry.Date))];
  const sortedDates = uniqueDates.sort((a, b) => new Date(a) - new Date(b));
  const suppliers = [...new Set(priceTrendData.map(entry => entry.Supplier))];

  const series = suppliers.map(supplier => {
    const data = sortedDates.map(date => {
      const record = priceTrendData.find(
        e => e.Supplier === supplier && e.Date === date
      );
      if (!record) return { x: date, y: null, deltaValue: null };

      const priceEntry = record.Prices[0]; // assuming one price per supplier/date

      let deltaValue = null;

    //   if(key == "priceTrend") deltaValue = priceEntry?.DeltaBest ?? null;
    //   else if(key == "priceTrendMinMax") deltaValue = priceEntry?.DeltaWorst ?? null;
    //   else if(key == "forwardCurve") deltaValue = priceEntry?.DeltaNextBest ?? null;
    //   else if(key == "forwardCurveMinMax") deltaValue = priceEntry?.DeltaNextWorst ?? null;

      deltaValue = priceEntry?.DeltaPrice ?? null;
      return {
        x: date,
        y: priceEntry?.Rank ?? null,       // rank goes on Y axis
        deltaValue: deltaValue // store DeltaBest for tooltip
      };
    });

    return {
      name: supplier,
      supplierId: priceTrendData.find(e => e.Supplier === supplier)
        ?.EnerexSupplierIdentifier,
      type: "line",
      data
    };
  });

  const formattedDates = sortedDates.map(date => {
    if (!date) return "";
    // if (key?.includes("forwardCurve")) {
    //   const [MM, , YY] = date.split("/");
    //   return `${MM}/${YY}`;
    // }
    return date.slice(0, 5);
  });

  return { categories: formattedDates, series };
};

export const convertDeltaBestToChartData = (priceTrendData) => {
  if (!priceTrendData) return null;
  priceTrendData = filterLiveRankingData(priceTrendData);

  // Collect all unique dates
  const uniqueDates = [...new Set(priceTrendData.map(entry => entry.Date))];
  const sortedDates = uniqueDates.sort((a, b) => new Date(a) - new Date(b));

  // Collect all unique suppliers across all dates
  const suppliers = [
    ...new Set(
      priceTrendData.flatMap(entry =>
        entry.Suppliers.map(s => s.Supplier)
      )
    )
  ];

  const series = suppliers.map(supplier => {
    const data = sortedDates.map(date => {
      const dayEntry = priceTrendData.find(e => e.Date === date);
      const supplierEntry = dayEntry?.Suppliers.find(s => s.Supplier === supplier);

      if (!supplierEntry) {
        return { x: date, y: null };
      }

      return {
        x: date,
        y: supplierEntry?.Rank ?? null, // you can swap this to CurrPrice if you want
        rank: supplierEntry?.Rank ?? null,
        currPrice: supplierEntry?.Deltas[0]?.CurrPrice ?? null,
        deltaBest: supplierEntry?.Deltas[0]?.BestPrice ?? null,
        deltaWorst: supplierEntry?.Deltas[0]?.WorstPrice ?? null,
        deltaNextBetter: supplierEntry?.Deltas[0]?.NextBetterPrice ?? null,
        deltaNextWorse: supplierEntry?.Deltas[0]?.NextWorsePrice ?? null
      };
    });

    return {
      name: supplier,
      supplierId: priceTrendData
        .flatMap(e => e.Suppliers)
        .find(s => s.Supplier === supplier)?.EnerexSupplierIdentifier,
      type: "line",
      data
    };
  });

  // Format dates for chart categories
  const formattedDates = sortedDates.map(date => {
    if (!date) return "";
    return date.slice(0, 5); // e.g. MM/DD
  });

  return { categories: formattedDates, series };
};

